export default "__VITE_ASSET__DxmGAM0N__"